"use strict";

angular.module("customer")
.controller("OrderTemplateDetailsController", function(
    $rootScope, $scope, $state, $stateParams, gettextCatalog, common, Language, FlashBag, ModalService,
    OrderTemplateService, UserService
) {
    Language.initializeScope($scope, "language", "locale");
    $scope.weekdays = common.getISOWeekdays($scope.locale);

    $scope.$on("LanguageChanged", function(obj, locale) {
        $scope.weekdays = common.getISOWeekdays(locale);
    });

    $scope.orderTemplateService = OrderTemplateService;
    $scope.orderTemplate = OrderTemplateService.get($stateParams.id);

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
        }
    });

    this.generateCartFromOrderTemplate = function(templateId) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Create order"),
                    message: gettextCatalog.getString("Do you really want to create an order from this template?"),
                    confirmTextButton: gettextCatalog.getString("Create order")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(confirm) {
                if (!confirm) {
                    return;
                }
                OrderTemplateService.generateCartFromOrderTemplate(templateId).then(
                    function onSuccess(response) {
                        FlashBag.success(gettextCatalog.getString("The cart was generated successfully."), true);
                        if (response.data && response.data.missing_products && response.data.missing_products.length) {
                            var warningMessage = gettextCatalog.getPlural(
                                response.data.missing_products.length,
                                "The product below is not accessible:",
                                "The products below are not accessible:"
                            );
                            OrderTemplateService.showMissingProductsWarning(response.data.missing_products, warningMessage);
                        }
                        $rootScope.UpdateCurrentNumbers();
                        $state.go('shoppingCart');
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            });
        });
    };

    this.generateCartToModifyOrderTemplate = function(templateId) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Modify template"),
                    message: gettextCatalog.getString("Do you really want to modify this template?"),
                    confirmTextButton: gettextCatalog.getString("Modify template")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.close.then(function(confirm) {
                if (!confirm) {
                    return;
                }
                OrderTemplateService.generateCartToModifyOrderTemplate(templateId).then(
                    function onSuccess(response) {
                        OrderTemplateService.orderTemplateName = "";
                        FlashBag.info(gettextCatalog.getString("You can now modify the products and/or the name of your template and click 'Save template'."), true);
                        if (response.data && response.data.missing_products && response.data.missing_products.length) {
                            var warningMessage = gettextCatalog.getPlural(
                                response.data.missing_products.length,
                                "The product below is not accessible and will be removed from your template if you save without it:",
                                "The products below are not accessible and will be removed from your template if you save without them:"
                            );
                            OrderTemplateService.showMissingProductsWarning(response.data.missing_products, warningMessage);
                        }
                        $rootScope.UpdateCurrentNumbers();
                        $state.go('shoppingCart');
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            });
        });
    };

    this.seeAllLogs = function() {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("./modals/standing-order-logs.modal.html"),
            controller: "standingOrderLogsModalController",
            controllerAs: "standingOrderLogsModalCtrl",
            inputs: {
                $attrs: {
                    orderTemplateId: $scope.orderTemplate.id
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function() {
                modal.element.remove();
            });
        });
    };

    this.getStandingOrderAvailableDeliveryWeekdays = function(selectedWeekdays, availableWeekdays) {
        return OrderTemplateService.getStandingOrderAvailableDeliveryWeekdays($scope.weekdays, selectedWeekdays, availableWeekdays);
    };

    this.getStandingOrderUnavailableDeliveryWeekdays = function(selectedWeekdays, availableWeekdays) {
        return OrderTemplateService.getStandingOrderUnavailableDeliveryWeekdays($scope.weekdays, selectedWeekdays, availableWeekdays);
    };

    this.seeOrder = function(orderId) {
        $state.go('orderDetails', {id: orderId});
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order-template/order-template-details.controller.js
// module id = 968
// module chunks = 0